import { camelCaseToDash } from '#/utils/string';

export function getFieldQaId(name: string) {
  return camelCaseToDash(name).replace(/\./g, '-');
}
